<template>
  <app-logged id="LaudosCreate">
    <v-flex xs12>
      <validation-observer
        ref="observer"
        v-slot="{ invalid }"
        tag="form"
      >
        <v-form>
          <app-widget
            actions
            class-widget="md6 offset-md3 sm8 offset-sm2 xs12"
          >
            <div slot="widget-content">
              <AppFormHeader
                title="Responsável"
                icon="supervised_user_circle"
              />
              <validation-provider
                name="contrato"
                rules="required"
                v-slot="{ errors }"
              >
                <v-autocomplete
                  :items="industriasDoCliente"
                  v-model="laudo.contrato_id"
                  :disabled="!!laudo.id"
                  label="Contrato cliente/industria"
                  :return-object="false"
                  :item-text="contrato"
                  item-value="id"
                  item-disabled="contrato_fim"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="data da coleta"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="date"
                  v-model="laudo.data_coleta"
                  label="Data da coleta"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="data da analise"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="date"
                  v-model="laudo.data_analise"
                  label="Data da análise"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="numero da amostra"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="tel"
                  v-model="laudo.amostra_numero"
                  label="Número da amostra"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <AppFormHeader
                title="Informações"
                icon="description"
              />
              <validation-provider
                name="gordura"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="tel"
                  clearable
                  v-model="laudo.gordura"
                  label="Gordura"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="proteina"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="tel"
                  clearable
                  v-model="laudo.proteina"
                  label="Proteína"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="lactose"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="tel"
                  clearable
                  v-model="laudo.lactose"
                  label="Lactose"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="solidos"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="tel"
                  clearable
                  v-model="laudo.solidos"
                  label="Sólidos"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="esd"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="tel"
                  clearable
                  v-model="laudo.esd"
                  label="ESD"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="ccs"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="tel"
                  clearable
                  v-model="laudo.ccs"
                  label="CCS"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="cpp"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="tel"
                  clearable
                  v-model="laudo.cpp"
                  label="CPP"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="produção"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="tel"
                  clearable
                  v-model="laudo.producao"
                  label="Produção"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <v-checkbox
                v-if="!!laudo.id"
                v-model="laudo.completo"
                :label="`Ignorar campos incompletos`"
              />
            </div>
            <div slot="widget-actions">
              <app-button
                v-if="laudo.id"
                class="mr-2"
                @click.native="remove"
                color="error"
              >
                remover
              </app-button>
              <app-button
                @click.native.prevent="save()"
                :disable="invalid"
              >
                salvar
              </app-button>
            </div>
          </app-widget>
        </v-form>
      </validation-observer>
    </v-flex>
  </app-logged>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import AppLogged from '@/components/layouts/AppLogged'
import AppWidget from '@/components/AppWidget'
import AppButton from '@/components/AppButton'
import AppFormHeader from '@/components/AppFormHeader'
export default {
  name: 'LaudosCreate',
  components: {
    AppWidget,
    AppLogged,
    ValidationProvider,
    ValidationObserver,
    AppFormHeader,
    AppButton
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['laudo', 'industriasDoCliente'])
  },
  methods: {
    ...mapActions(['postSaveLaudo', 'deleteLaudo']),
    contrato: item => `${item.nome_cliente} (${item.nome_industria})`,
    goToLaudoIndex () {
      this.$router.push({
        name: 'laudos-index'
      })
    },
    remove () {
      if (confirm('Confirme a exclusão deste laudo.')) {
        this.deleteLaudo().then(res => {
          this.goToLaudoIndex()
        })
      }
    },
    save () {
      this.$refs.observer.validate().then(result => {
        if (result) {
          this.postSaveLaudo().then(res => {
            this.goToLaudoIndex()
          })
        }
      })
    }
  },
  mounted () {}
}
</script>
